import React, { useEffect, useMemo, useState } from 'react';
import {
  Box, ChevronDownIcon, ChevronUpIcon, Heading, RawButton,
} from '@common-fe/common-fe';

import { useModulesCollapseStore } from '../stores';

interface Props {
  children?:React.ReactNode;
  icon?:React.ReactNode;
  title?: string;
  anchorId: string;
  isDefaultExtended?: boolean;
  actions?: React.ReactNode;
  wrapperTestId?: string;
  titleTestId?: string;
}

const ModuleWrapper: React.FC<Props> = ({
  children,
  title,
  anchorId,
  isDefaultExtended,
  icon,
  actions,
  wrapperTestId,
  titleTestId,
}) => {
  const isExtendingUsed = useMemo(() => typeof isDefaultExtended === 'boolean', [isDefaultExtended]);
  const [isExtended, setIsExtended] = useState(Boolean(isDefaultExtended));
  const collapseSignal = useModulesCollapseStore((state) => state.collapseSignal);
  const expandSignal = useModulesCollapseStore((state) => state.expandSignal);

  useEffect(() => {
    if (isExtendingUsed && collapseSignal > 0) {
      setIsExtended(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapseSignal]);

  useEffect(() => {
    if (isExtendingUsed && expandSignal > 0) {
      setIsExtended(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expandSignal]);

  return (
    <div id={anchorId}>
      <Box direction="column" margin={{ bottom: 'spacing16' }}>
        {
          title ? (
            <Box
              direction="row"
              justify="between"
              data-testid={wrapperTestId}
            >
              {isExtendingUsed ? (
                <RawButton
                  data-testid={`${anchorId}_toggle`}
                  onClick={() => setIsExtended(!isExtended)}
                >
                  <Box direction="row" align="center">
                    <Box margin={{ right: 'spacing16' }}>
                      { isExtended ? (
                        <ChevronUpIcon color="textTitle" />
                      ) : (
                        <ChevronDownIcon color="textTitle" />
                      )}
                    </Box>
                    {icon ? (
                      <Box margin={{ right: 'spacing16' }}>
                        {icon}
                      </Box>
                    ) : null}
                    <Heading fill level={4} size="21px" data-testid={titleTestId}>
                      {title}
                    </Heading>
                  </Box>
                </RawButton>
              ) : (
                <Box direction="row" align="center">
                  {icon ? (
                    <Box margin={{ right: 'spacing16' }}>
                      {icon}
                    </Box>
                  ) : null}
                  <Heading fill level={4} size="21px" data-testid={titleTestId}>
                    {title}
                  </Heading>
                </Box>
              )}
              {actions ? (
                <Box direction="row" align="center" justify="end">
                  {actions}
                </Box>
              ) : null}
            </Box>
          ) : null
        }

        <Box direction="column" pad={{ bottom: 'spacing16' }} border={{ side: 'bottom', color: 'border1' }}>
          <Box direction="column">
            {(isExtendingUsed && isExtended) || !isExtendingUsed ? (
              title ? (
                <Box margin={{ top: 'spacing16' }}>
                  {children}
                </Box>
              ) : children
            ) : null}
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default ModuleWrapper;
